import {
  Box,
  Typography,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

const Review = () => {
    return (
        <>
        {/* REVIEW SECTION */ }
        <Box
            component="a"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfZIqI2YlSATLuS-SME8_NTl8z0rNp1vyWMtDQF6ua0OrGbSw/viewform?usp=publish-editor"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
                margin: 'auto',
                marginTop: '5vh',
                bgcolor: 'background.paper',
                borderRadius: '8px',
                textAlign: 'center',
                maxWidth: '500px', // Prevents it from getting too wide on desktop
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textDecoration: 'none',
                color: 'text.primary',
                p: 3,
                boxShadow: 2,
                transition: '0.2s',
                '&:hover': {
                    bgcolor: 'grey.50',
                    transform: 'translateY(-2px)', // Slight lift effect
                    boxShadow: 4
                }
            }}
        >
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                All feedback will be used to determine the direction of this platform so please mention any new features you wish to see.
            </Typography>

            <Box sx={{ mb: 2, '& svg': { color: '#FFD700', fontSize: '2rem' } }}>
                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
            </Box>

            {/* FIXED: Changed Button to a div-styled Box so we don't nest <a> and <button> */}
            <Box
                sx={{
                    bgcolor: '#1976d2',
                    color: '#ffffff',
                    px: 3,
                    py: 1,
                    borderRadius: '4px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    fontSize: '0.875rem'
                }}
            >
                Leave a review
            </Box>
        </Box>
        </>
        )
};

export default Review;